import { render, staticRenderFns } from "./Numbers.vue?vue&type=template&id=576c0adc&scoped=true&"
import script from "./Numbers.vue?vue&type=script&lang=js&"
export * from "./Numbers.vue?vue&type=script&lang=js&"
import style0 from "./Numbers.vue?vue&type=style&index=0&id=576c0adc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "576c0adc",
  null
  
)

export default component.exports